import { Container } from '@mui/material';

/**
 * Um contêiner reutilizável para páginas internas,
 * com padding e largura máxima consistente.
 */
export default function PageContainer({ children, sx, maxWidth = "xl" }) {
  return (
    <Container maxWidth={maxWidth} sx={{ p: 3, ...sx }}>
      {children}
    </Container>
  );
}
